import { barLine } from "../options/bar-line";
import getEmphasis from "./get-emphasis";
import { lengthDataHandler } from "./get-length";
import { groupArrays } from "./group-arrays";

type TProps = {
  primaryColor?: string;
  colors: string[];
  type: "bar-line";
  data: Record<string, string>[][];
  payload: Record<string, unknown>;
};

export const BarLineData = ({
  data,
  colors,
  primaryColor,
  payload,
}: TProps) => {
  const [seriesTitles, ...restData] = data;
  seriesTitles.shift();
  const grouped = groupArrays(
    restData.map((row) => row.filter((cell) => !!cell?.value)),
  );
  const [axisTitles = [], ...gropedData] = grouped;
  const titles = axisTitles.map((cell) => cell?.value ?? "");

  let series = gropedData.map((arr, i) => {
    const mapped = arr.map((cell) => cell?.value ?? 0);
    const seriesColor = colors[i] ?? primaryColor;
    const type = seriesTitles[i]?.["bar-line"] ?? "bar";
    const lineWidth = isNaN(payload.lineSize as number)
      ? 1
      : Number(payload.lineSize);

    return {
      data: mapped,
      type,
      itemStyle: { color: seriesColor },
      name: seriesTitles[i]?.value ?? "",
      // universalTransition: true,
      animationDurationUpdate: 1000,
      emphasis: getEmphasis(seriesColor),
      ...(type === "line" && {
        symbolSize: lineWidth * 1.5,
        smooth: !!payload.smoothLine,
        lineStyle: {
          width: lineWidth,
        },
      }),
    };
  });

  if (series.length === 1) {
    const seriesData = series[0].data.map((value, index) => {
      const itemColor = colors[index] ?? primaryColor;
      return {
        value,
        itemStyle: { color: itemColor },
        emphasis: getEmphasis(itemColor),
      };
    });
    series = [
      {
        data: seriesData,
        type: seriesTitles[0]?.["bar-line"] ?? "bar",
        name: seriesTitles[0]?.value ?? "",
        // universalTransition: true,
        animationDurationUpdate: 1000,
      },
    ] as any[];
  }

  return {
    option: barLine(payload, { titles, series }),
    ...lengthDataHandler(titles, series),
  };
};
